import { render, staticRenderFns } from "./price-range.vue?vue&type=template&id=54f488f1&"
import script from "./price-range.vue?vue&type=script&lang=js&"
export * from "./price-range.vue?vue&type=script&lang=js&"
import style0 from "./price-range.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports